import { Component, Input, OnInit } from '@angular/core';
import { IEventResult } from 'src/app/models/results/eventResult.interface';
import { IScoreGroup } from 'src/app/models/results/scoreGroup.interface';
import { ViewConfigurations } from 'src/app/models/util/viewConfigurations';

@Component({
  selector: 'app-results-events-group',
  templateUrl: './results-events-group.component.html',
  styleUrls: ['./results-events-group.component.less']
})
export class ResultsEventsGroupComponent {
  public viewConfigurations = ViewConfigurations;

  constructor() { }

  @Input()
  eventResults: IEventResult[];

  @Input()
  scoreGroups: IScoreGroup[];

}
